export interface IPostCrearEquipo {
  nombre: string;
  modeloId: string;
  horometro: number;
}
export const initialPostCrearEquipo = {
  nombre: "",
  modeloId: "",
  horometro: 0,
};

export interface IFilterTableEquipo {
  skip: number;
  take: number;
  search?: string | null;
}

export const initialFIlterTableEquipo = {
  skip: 0,
  take: 50,
  search: "",
};

export interface IDataTableEquipo {
  equipoId: string;
  nombre: string;
  modelo: string;
  fechaCreada: string;
  horometro: string;
  ultimaVerificacion: string;
}

export interface IDatoModeloEquipo {
  nombreModelo: string;
  modeloEquipoId: string;
}

export interface IFilterTableEquipoPorModelo {
  skip: number;
  take: number;
  search?: string | null;
  modeloEquipoId?: string;
}

export const initialFilterTableEquipoPorModelo: IFilterTableEquipoPorModelo = {
  skip: 0,
  take: 40,
  search: "",
  modeloEquipoId: "",
};

export interface IActualizarEquipo {
  EquipoId: string;
  Nombre: string;
}